module.exports = __webpack_public_path__ + "static/media/male.cb3bb94a.png";